<template>
  <div class="min-h-screen">
    <div class="relative overflow-hidden">

      <main>
        <div class="pt-10 bg-awtmtn-navy sm:pt-16 lg:pt-8 lg:pb-14 overflow-hidden">
          <div class="mx-auto max-w-7xl lg:px-8">
            <div class="lg:grid lg:grid-cols-2 lg:gap-8">
              <div class="mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 sm:text-center lg:px-0 lg:text-left lg:flex lg:items-center">
                <div class="lg:py-24">
 
                  <h1 class="mt-4 text-4xl tracking-tight font-extrabold text-white sm:mt-5 sm:text-6xl lg:mt-6 xl:text-6xl">
                    <span class="block">Accelerating R&D</span>
                    <span class="block text-awtmtn-blue">for Operational Advantage</span>
                  </h1>
                  <p class="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                    Awetomaton brings together human ingenuity, domain expertise and modern AI to turn the ever growing data volumes into actionable intelligence. 
                    Applying experience across Research and Development, Integration and Operations, we accelerate this applied research into operational national security solutions.
                  </p>
                </div>
              </div>
              <div class="mt-12 -mb-16 sm:-mb-48 lg:m-0 lg:relative">
                <div class="mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 lg:max-w-none lg:px-0">
                  <img class="w-full lg:absolute lg:inset-y-0 lg:left-0 lg:h-full lg:w-auto lg:max-w-none" :src="cloudIllustration" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>



    

        <!-- Brand Strip -->
        <!-- <div class="bg-gray-100">
          <div class="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            <div class="lg:grid lg:grid-cols-2 lg:gap-8">
              <h2 class="max-w-md mx-auto text-3xl font-extrabold text-awtmtn-blue text-center lg:max-w-xl lg:text-left">
                {{ BrandStrip.Title }}
              </h2>
              <div class="flow-root self-center mt-8 lg:mt-0">
                <div class="-mt-4 flex flex-wrap justify-around lg:-ml-4">
                  <div v-for="brand in BrandStrip.brands" :key="brand.ImageAlt" class="mt-4 ml-8 flex flex-grow flex-shrink-0 justify-around lg:flex-grow-0 lg:ml-4">
                    <img class="h-12" :src="brand.Image" :alt="brand.ImageAlt" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- pick one... -->
        <div class="bg-gray-100">
          <div class="max-w-2xl mx-auto py-16">
            <h2 class="text-2xl font-extrabold text-awtmtn-navy">{{ BrandStrip.Title }}
            </h2>
            <div class="flow-root mt-8 lg:mt-10">
              <div class="-mt-2 flex flex-wrap justify-around ">
                <div v-for="brand in BrandStrip.brands" :key="brand.ImageAlt" class="mt-4 flex">
                  <img class="h-10 w-auto object-contain" :src="brand.Image" :alt="brand.ImageAlt" />
                </div>
              </div>
            </div>
          </div>
        </div>


    <!-- Data Science -->
    
      <div class="relative bg-white max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8 overflow-hidden">
        <svg class="absolute top-0 left-full transform -translate-x-1/2 -translate-y-3/4 lg:left-auto lg:right-full lg:translate-x-2/3 lg:translate-y-1/4" width="404" height="784" fill="none" viewBox="0 0 404 784" aria-hidden="true">
          <defs>
            <pattern id="8b1b5f72-e944-4457-af67-0c6d15a99f38" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="404" height="784" fill="url(#8b1b5f72-e944-4457-af67-0c6d15a99f38)" />
        </svg>

        <div class="relative lg:grid lg:grid-cols-3 lg:gap-x-8">
          <div class="lg:col-span-1">
            <h2 id="data-science" class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">{{ RemoteSensing.header }}</h2>
          </div>
          <dl class="mt-10 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-8 sm:gap-y-10 lg:mt-0 lg:col-span-2">
            <div v-for="feature in RemoteSensing.features" :key="feature.name">
              <dt>
                <div class="flex items-center justify-center h-12 w-12 rounded-md bg-awtmtn-blue text-white">
                  <component v-if="feature.icon === 'ChipIcon'" :is="ChipIcon" class="h-6 w-6" aria-hidden="true" />
                  <component v-else-if="feature.icon === 'DatabaseIcon'" :is="DatabaseIcon" class="h-6 w-6" aria-hidden="true" />
                  <component v-else-if="feature.icon === 'LightningBoltIcon'" :is="LightningBoltIcon" class="h-6 w-6" aria-hidden="true" />
                  <component v-else-if="feature.icon === 'SearchIcon'" :is="SearchIcon" class="h-6 w-6" aria-hidden="true" />
                  <component v-else-if="feature.icon === 'BeakerIcon'" :is="BeakerIcon" class="h-6 w-6" aria-hidden="true" />
                </div>
                <p class="mt-5 text-lg leading-6 font-medium text-left text-gray-900">{{ feature.name }}</p>
              </dt>
              <dd class="mt-2 text-base text-left text-gray-500" v-html="feature.overview">
              </dd>
            </div>
          </dl>
        </div>
      </div>


    <!-- Cloud Architecture -->
    <div class="relative bg-white py-12 overflow-hidden">
      <div class="mx-auto max-w-md px-4 pb-12 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
        <h2 id="devsecops" class="text-base font-semibold tracking-wider text-awtmtn-blue uppercase">{{ CloudArchitecture.header }}</h2>
        <p class="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">{{ CloudArchitecture.subheader }}</p>
        <p class="mt-5 max-w-prose mx-auto text-xl text-gray-500" v-html="CloudArchitecture.overview"></p>
      </div>
      <!-- Section 1 -->
      <div class="relative">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
          <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
            <div>
              <div>
                <span class="h-12 w-12 rounded-md flex items-center justify-center bg-awtmtn-blue text-white">
                  <component v-if="CloudArchitecture.Section1.Icon === 'ServerIcon'" :is="ServerIcon" class="h-6 w-6" aria-hidden="true" />
                  <component v-else-if="CloudArchitecture.Section1.Icon === 'ShieldCheckIcon'" :is="ShieldCheckIcon" class="h-6 w-6" aria-hidden="true" />
                  <component v-else-if="CloudArchitecture.Section1.Icon === 'CodeIcon'" :is="CodeIcon" class="h-6 w-6" aria-hidden="true" />
                </span>
              </div>
              <div class="mt-6 text-left">
                <h2  id="cloud-architecture" class="text-3xl font-extrabold tracking-tight text-gray-900">
                  {{ CloudArchitecture.Section1.Title}}
                </h2>
                <p class="mt-4 text-lg text-gray-500" v-html="CloudArchitecture.Section1.Overview">
                </p>
              </div>
            </div>
          </div>
          <div class="mt-12 sm:mt-16 lg:mt-0">
            <div class="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
              <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none" :src="CloudArchitecture.Section1.Image" :alt="CloudArchitecture.Section1.ImageAlt" />
            </div>
          </div>
        </div>
      </div>
      <!-- Section 2 -->
      <div class="mt-20">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
          <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2">
            <div>
              <div>
                <span class="h-12 w-12 rounded-md flex items-center justify-center bg-awtmtn-blue text-white">
                  <component v-if="CloudArchitecture.Section2.Icon === 'ServerIcon'" :is="ServerIcon" class="h-6 w-6" aria-hidden="true" />
                  <component v-else-if="CloudArchitecture.Section2.Icon === 'ShieldCheckIcon'" :is="ShieldCheckIcon" class="h-6 w-6" aria-hidden="true" />
                  <component v-else-if="CloudArchitecture.Section2.Icon === 'CodeIcon'" :is="CodeIcon" class="h-6 w-6" aria-hidden="true" />
                </span>
              </div>
              <div class="mt-6 text-left">
                <h2 class="text-3xl font-extrabold tracking-tight text-gray-900">
                  {{ CloudArchitecture.Section2.Title}}
                </h2>
                <p class="mt-4 text-lg text-gray-500" v-html="CloudArchitecture.Section2.Overview">
                </p>
              </div>
            </div>
          </div>
          <div class="mt-12 sm:mt-16 lg:mt-0">
            <div class="pr-4 -ml-48 sm:pr-6 md:-ml-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
              <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:right-0 lg:h-full lg:w-auto lg:max-w-none" :src="CloudArchitecture.Section2.Image" :alt="CloudArchitecture.Section2.ImageAlt" />
            </div>
          </div>
        </div>
      </div>
      <!-- Section 3 -->
      <div class="mt-20">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
          <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
            <div>
              <div>
                <span class="h-12 w-12 rounded-md flex items-center justify-center bg-awtmtn-blue text-white">
                  <component v-if="CloudArchitecture.Section3.Icon === 'ServerIcon'" :is="ServerIcon" class="h-6 w-6" aria-hidden="true" />
                  <component v-else-if="CloudArchitecture.Section3.Icon === 'ShieldCheckIcon'" :is="ShieldCheckIcon" class="h-6 w-6" aria-hidden="true" />
                  <component v-else-if="CloudArchitecture.Section3.Icon === 'CodeIcon'" :is="CodeIcon" class="h-6 w-6" aria-hidden="true" />
                </span>
              </div>
              <div class="mt-6 text-left">
                <h2  id="cloud-architecture" class="text-3xl font-extrabold tracking-tight text-gray-900">
                  {{ CloudArchitecture.Section3.Title }}
                </h2>
                <p class="mt-4 text-lg text-gray-500" v-html="CloudArchitecture.Section3.Overview">
                </p>
              </div>
            </div>
          </div>
          <div class="mt-12 sm:mt-16 lg:mt-0">
            <div class="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
              <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none" :src="CloudArchitecture.Section3.Image" :alt="CloudArchitecture.Section3.ImageAlt" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DevSecOps Section -->
    <div class="relative bg-white py-12">
      <div class="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
        <h2 class="text-base font-semibold tracking-wider text-awtmtn-blue uppercase">{{ DevSecOps.header }}</h2>
        <p class="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">{{ DevSecOps.subheader }}</p>
        <p class="mt-5 max-w-prose mx-auto text-xl text-gray-500" v-html="DevSecOps.overview"></p>
        <div class="mt-12">
          <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            <div v-for="feature in DevSecOps.features" :key="feature.name" class="pt-6">
              <div class="flow-root bg-gray-50 rounded-lg px-6 pb-8">
                <div class="-mt-6">
                  <div>
                    <span class="inline-flex items-center justify-center p-3 bg-awtmtn-blue rounded-md shadow-lg">
                      <component v-if="feature.icon === 'LockClosedIcon'" :is="LockClosedIcon" class="h-6 w-6 text-white" aria-hidden="true" />
                      <component v-else-if="feature.icon === 'ClipboardCheckIcon'" :is="ClipboardCheckIcon" class="h-6 w-6 text-white" aria-hidden="true" />
                      <component v-else-if="feature.icon === 'EyeIcon'" :is="EyeIcon" class="h-6 w-6 text-white" aria-hidden="true" />
                    </span>
                  </div>
                  <h3 class="mt-8 text-lg font-medium text-gray-900 tracking-tight">{{ feature.name }}</h3>
                  <p class="mt-5 text-base text-gray-500" v-html="feature.overview">
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


        <!-- More main page content here... -->

        <div class="bg-awtmtn-navy">
          <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
            <p class="text-xl text-gray-300 text-center max-w-4xl mx-auto">
              Our seasoned team—uniting Remote Sensing Solutions, Cloud & Platform Expertise, and DevSecOps Adoption—enables <i>rapid transformation</i> of R&D concepts into operational capabilities.
            </p>
          </div>
        </div>

        <div class="bg-blue-50">
          <div class="max-w-7xl mx-auto text-center py-8 px-4 sm:px-6 lg:py-12 lg:px-8">
            <h2 class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              <span class="block">Ready to see how we can help?</span>
            </h2>
            <div class="mt-8 flex justify-center">
              <div class="ml-3 inline-flex">
                <router-link to="/contact" class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-awtmtn-blue hover:bg-awtmtn-dark-blue cursor-pointer">
                  Contact us
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script lang="ts">
import { DevSecOps, CloudArchitecture, RemoteSensing } from '../data/solutions.json'
import { BrandStrip } from '../data/home.json'
import { defineComponent, computed, ref } from 'vue'
import { useKeenSlider } from 'keen-slider/vue.es'
import { 
  ChevronLeftIcon, 
  ChevronRightIcon, 
  ChipIcon, 
  DatabaseIcon, 
  LightningBoltIcon, 
  SearchIcon,
  ServerIcon,
  ShieldCheckIcon,
  CodeIcon,
  XCircleIcon,
  BeakerIcon,
  LockClosedIcon,
  ClipboardCheckIcon,
  EyeIcon
} from '@heroicons/vue/outline'
import cloudIllustration from '@/assets/svg/cloud-illustration-right.svg'

// Import PNG images
import awsImage from '@/assets/png/aws.png'
import azureImage from '@/assets/png/azure.png'
import k8sImage from '@/assets/png/k8s.png'
import openshiftImage from '@/assets/png/openshift.png'
import argoImage from '@/assets/png/argo.png'
import dockerImage from '@/assets/png/docker.png'
import gitlabImage from '@/assets/png/gitlab.png'
import reactImage from '@/assets/png/react.png'
import tensorflowImage from '@/assets/png/tensorflow.png'

import 'keen-slider/keen-slider.min.css'

export default defineComponent({
  name: 'Home',
  setup() {
    // Transform the BrandStrip to use imported images
    const transformedBrandStrip = {
      ...BrandStrip,
      brands: BrandStrip.brands.map(brand => {
        const imageMap = {
          '/assets/png/aws.png': awsImage,
          '/assets/png/azure.png': azureImage,
          '/assets/png/k8s.png': k8sImage,
          '/assets/png/openshift.png': openshiftImage,
          '/assets/png/argo.png': argoImage,
          '/assets/png/docker.png': dockerImage,
          '/assets/png/gitlab.png': gitlabImage,
          '/assets/png/react.png': reactImage,
          '/assets/png/tensorflow.png': tensorflowImage
        }
        return {
          ...brand,
          Image: imageMap[brand.Image as keyof typeof imageMap] || brand.Image
        }
      })
    }

    return {
      DevSecOps,
      CloudArchitecture,
      RemoteSensing,
      BrandStrip: transformedBrandStrip,
      cloudIllustration,
      ChipIcon,
      DatabaseIcon,
      LightningBoltIcon,
      SearchIcon,
      ServerIcon,
      ShieldCheckIcon,
      CodeIcon,
      XCircleIcon,
      ChevronLeftIcon,
      ChevronRightIcon,
      BeakerIcon,
      LockClosedIcon,
      ClipboardCheckIcon,
      EyeIcon
    }
  }
})
</script>

<style>
.navigation-wrapper {
  position: relative;
}
.dots {
  display: flex;
  padding: 10px 0;
  justify-content: center;
}
.dot {
  border: none;
  width: 10px;
  height: 10px;
  background: #c5c5c5;
  border-radius: 50%;
  margin: 0 5px;
  padding: 5px;
  cursor: pointer;
}
.dot:focus {
  outline: none;
}
.dot.active {
  background: #000;
}
.arrow {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  cursor: pointer;
}
.arrow--left {
  left: 5px;
}
.arrow--right {
  left: auto;
  right: 5px;
}
.arrow--disabled {
  fill: rgba(255, 255, 255, 0.5);
}
</style>